import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Form, Input, Spin } from "antd";
import CustomerResource from "./api/CustomerResource";
import { axiosErrorHandler } from "../../../../swzutils";
const CustomerDeliveryInstructionsFormItem = ({ customerId, form }) => {
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        if (customerId && !loading) {
            loadCustomerDeliveryInstructions(customerId);
        }
    }, [customerId]);
    const loadCustomerDeliveryInstructions = (customerId) => {
        setLoading(true);
        CustomerResource.getDeliveryInstructions(customerId, customerDeliveryInstructions => form.setFieldValue("instructions", customerDeliveryInstructions.deliveryInstructions), axiosErrorHandler, () => setLoading(false));
    };
    return (_jsx(Spin, { spinning: loading, children: _jsx(Form.Item, { name: "instructions", label: "Instructions", rules: [{
                    max: 5000, message: 'Please limit the instructions to 5000 characters.'
                }], children: _jsx(Input.TextArea, { rows: 2 }) }) }));
};
export default CustomerDeliveryInstructionsFormItem;
